module.exports = __webpack_public_path__ + "static/media/woman-office.4213bd16.jpg";